import Component from '@averyano/core/src/classes/Component';
import CartController from './cart-controller';
import GSAP from 'gsap';

export default class CartBagElement extends Component {
	constructor() {
		super({
			element: '.cart',
			elements: {
				bagCount: '.cart__number-inside',
				bagIcon: '.cart__icon',
			},
		});
	}

	create() {
		super.create();
		this.addEventListeners();
		this.updateUi();
	}

	addEventListeners() {
		this.element.addEventListener('click', () => {
			this.$emit('viewShoppingCart');
		});
	}

	show() {
		GSAP.to(this.element, {
			autoAlpha: 1,
		});
	}
	hide() {
		GSAP.to(this.element, {
			autoAlpha: 0,
		});
	}
	updateUi() {
		this.elements.bagCount.innerHTML = CartController.itemsInCart.length;
		if (CartController.itemsInCart.length > 0) {
			this.show();
		} else {
			this.hide();
		}
	}
}
